import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';

export interface ApiProjectTeamMemberResponse {
  id: number;
  fullName: string;
  jobTitle: string;
  description: string;
  profilePicture?: string;
  linkedinProfile?: string;
}

interface ApiProjectTeamMemberCreateRequest {
}

export class ProjectTeamMemberFactory extends BaseFactory<ProjectTeamMember> {
  public toEntity(args: ApiProjectTeamMemberResponse): ProjectTeamMember {
    return new ProjectTeamMember({
      id: args.id,
      fullName: args.fullName,
      jobTitle: args.jobTitle,
      description: args.description,
      profilePicture: args.profilePicture ? {url: args.profilePicture} : undefined,
      linkedinProfile: args.linkedinProfile || undefined,
    });
  }

  public toRequest(projectTeamMember: ProjectTeamMember): ApiProjectTeamMemberCreateRequest {
    return projectTeamMember;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/ProjectTeamMemberFactory.tsx